import { Component, inject, ViewChild } from '@angular/core';
import {
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router,
  RouterOutlet,
  type Event,
} from '@angular/router';
import { SessionService } from '@core/services/session.service';
import { TitleService } from '@core/services/title.service';
import { NgProgressbar, NgProgressRef } from 'ngx-progressbar';
import { NgxSpinnerComponent } from 'ngx-spinner';
@Component({
  selector: 'app-root',
  imports: [RouterOutlet, NgProgressbar, NgxSpinnerComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  private titleService = inject(TitleService);
  private sessionService = inject(SessionService);

  progressRef!: NgProgressRef;

  @ViewChild(NgProgressRef) progressBar!: NgProgressRef;

  private router = inject(Router);

  constructor() {
    this.sessionService.restoreSessionTimer();
    this.router.events.subscribe((event: Event) => {
      this.checkRouteChange(event);
    });
  }

  ngOnInit(): void {
    this.titleService.init();
  }

  checkRouteChange(routerEvent: Event) {
    if (routerEvent instanceof NavigationStart) {
      this.progressBar.start();
    }
    if (
      routerEvent instanceof NavigationEnd ||
      routerEvent instanceof NavigationCancel ||
      routerEvent instanceof NavigationError
    ) {
      setTimeout(() => {
        this.progressBar.complete();
      }, 200);
    }
  }
}
